$(document).ready(function(){
    // Mobile menu toggle
    $('.menuToggle').on('click',function(e){
        e.preventDefault();
        $('.main-nav__links').slideToggle('fast');
        $(this).toggleClass('close');
    });

    // Close Mobile menu on Menu click
    $("#menu-nav li a").click(function () {
        $(".main-nav__links").attr("style", "display:none");
        $(".menuToggle").toggleClass('close');
    });
});

